export default __webpack_public_path__ + "static/media/icons.9451d5fe.woff2";